import script from "./GridNotesComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridNotesComponent.vue?vue&type=script&setup=true&lang=ts"

import "./GridNotesComponent.vue?vue&type=style&index=0&id=36c4011b&lang=css"

const __exports__ = script;

export default __exports__